import {useRef, useState} from 'react';

export const useProductTileImageSlider = (props: {
  renderOnlyFirstImage: boolean;
  setRenderOnlyFirstImage: (value: boolean) => void;
}) => {
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [previousSlide, setPreviousSlide] = useState<number | undefined>(
    undefined,
  );
  const sliderRef = useRef<HTMLUListElement>(null);
  const {renderOnlyFirstImage, setRenderOnlyFirstImage} = props;

  const handleOnScroll = (e: React.UIEvent<HTMLUListElement>) => {
    const currentSlideIndex = Math.abs(
      Math.round(e.currentTarget.scrollLeft / e.currentTarget.offsetWidth),
    );

    setPreviousSlide(currentSlide);
    setCurrentSlide(currentSlideIndex);
    renderOnlyFirstImage && setRenderOnlyFirstImage(false);
  };

  const handleScrollTo = (slide: number) => {
    sliderRef.current?.scrollTo({
      left: sliderRef.current.offsetWidth * slide,
      behavior: 'smooth',
    });
  };

  return {
    sliderRef,
    currentSlide,
    previousSlide,
    handleOnScroll,
    handleScrollTo,
  };
};
